import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { authenticateUser } from "actions-lib/authenticateUser"
import { withLDConsumer } from "launchdarkly-react-client-sdk"
import Login from "./Login"

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      authenticateUser,
    },
    dispatch,
  ),
})

// eslint-disable-next-line no-unused-vars
export const mapStateToProps = (state, ownProps) => ({
  siteLanguage: state.siteLanguage,
  userAccount: state.userAccount,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withLDConsumer()(Login))
